<template>
    <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal ">
        {{ nextStepResponsible }}
    </div>
</template>

<script setup>
import {ref, computed, defineProps} from 'vue'

const props = defineProps([
    'nextStep'
])

const nextStepResponsible = computed(() => {
    if(props.nextStep && props.nextStep.user){
        return `${props.nextStep.user.first_name} ${props.nextStep.user.last_name}`
    } else {
        return "--"
    }
})

</script>